// extracted by mini-css-extract-plugin
module.exports = {"container":"OrganisationsRoute_container__eVJQq","mainContainer":"OrganisationsRoute_mainContainer__35ZRr"};